/* eslint-disable @typescript-eslint/ban-ts-comment */
import { AnalyticsProvider } from '../AnalyticsProvider';

export default class FacebookPixelProvider implements AnalyticsProvider {
  name = 'facebook';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  track(eventName: string, properties?: Record<string, any>): void {
    // @ts-ignore
    window.fbq('track', eventName, properties);
  }
}
